import React, { useEffect, useState } from "react";
import DoughnutChart from "./doughnut-chart";

import clsx from "clsx";
import { Select } from "antd";
import {
  formatNumber,
  getDashboardSumission,
  getGroupByData,
} from "src/utils/helper/functions";
import { Colors } from "src/utils/data/constant";

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
};

type AssetsAllocationProps = {
  assets: any;
  showDetails?: boolean;
};

const AssetsAllocation: React.FC<AssetsAllocationProps> = ({
  assets,
  showDetails = false,
}: AssetsAllocationProps) => {
  const [assetsAllocationData, setAssetsAllocationData] = useState<any[]>([]);
  const [data, setData] = useState<any>(null);
  const [portfoliosCharts, setPortfoliosCharts] = useState<string[]>([
    "distribution",
  ]);
  const [title, setTitle] = useState<string>("Assets Allocation");
  const items: any = [
    {
      value: "distribution",
      label: "Portfolios Net Assets%",
    },
    {
      value: "allocation",
      label: "Assets allocation",
    },
    {
      value: "sector",
      label: "Assets by Sector",
    },
    {
      value: "country",
      label: "Assets by Country",
    },
    {
      value: "currency",
      label: "Assets by Investment Currency",
    },
    {
      value: "market",
      label: "Assets by Market",
    },
  ];

  const portfoliosChartChange = (value: any) => {
    setPortfoliosCharts(value);
  };

  useEffect(() => {
    if (portfoliosCharts.includes("distribution")) {
      prepareData("portfolioCode", "totalPercentageFromPortfolio");
      setTitle("Portfolios Net Assets%");
    } else if (portfoliosCharts.includes("allocation")) {
      prepareData("productGroupName", "totalPercentageFromPortfolio");
      setTitle("Assets allocation");
    } else if (portfoliosCharts.includes("sector")) {
      prepareData("secGroupName", "totalPercentageFromPortfolio");
      setTitle("Assets by Sector");
    } else if (portfoliosCharts.includes("country")) {
      prepareData("countryGroupName", "totalPercentageFromPortfolio");
      setTitle("Assets by Country");
    } else if (portfoliosCharts.includes("currency")) {
      prepareData("investmentCurrency", "totalPercentageFromPortfolio");
      setTitle("Assets by Investment Currency");
    } else if (portfoliosCharts.includes("market")) {
      prepareData("marketName", "totalPercentageFromPortfolio");
      setTitle("Assets by Market");
    }
  }, [assets, portfoliosCharts]);

  const prepareData = (keyName: string, keySum: string) => {
    const groupedData = getGroupByData(assets, keyName);
    const values: any = [];

    setAssetsAllocationData(
      Object.entries(groupedData)?.map(([key, value]: any) => {
        const summission =
          (getDashboardSumission(value, keySum) /
            getDashboardSumission(assets, keySum)) *
          100;
        values.push(summission);
        return {
          label: key,
          value: summission,
        };
      })
    );

    setData({
      labels: Object.keys(groupedData),
      datasets: [
        {
          label: "",
          data: values,
          backgroundColor: Colors,
          borderColor: Colors,
          borderWidth: 1,
          borderJoinStyle: "round",
          // borderRadius: 10,
          // spacing: 3,
          // rotation: 10
        },
      ],
    });
  };

  return (
    <div
      className={clsx(
        " h-full max-h-full p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-wrap flex w-full",
        showDetails ? "mt-3 flex-row slide-left" : "mt-0 flex-col slide-top"
      )}
    >
      <div
        className={clsx(
          "flex self-stretch w-full mb-3 justify-start items-start gap-3",
          showDetails
            ? "flex-col md:flex-row justify-between items-start md:items-center"
            : "flex-col"
        )}
      >
        <div className="opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold">
          {title}
        </div>
        <Select
          className={clsx(showDetails ? "w-full" : "w-full")}
          onChange={(value) => portfoliosChartChange(value)}
          placeholder={"Select a chart"}
          defaultValue={"distribution"}
          suffixIcon={
            <img
              className="w-[20px] h-[20px]"
              src="/images/dropdown-arrow.svg"
              alt="arrow-down"
            />
          }
          options={items}
        />
      </div>
      <div
        className={clsx(
          "h-[200px] flex items-center justify-center overflow-hidden",
          showDetails ? "w-full md:w-[49%] " : "w-full"
        )}
      >
        {data && <DoughnutChart data={data} options={options} />}
      </div>
      <div className="mt-3 flex flex-col grow gap-5 overflow-y-auto">
        {assetsAllocationData
          ?.filter((ele: any) => ele.value != 0)
          ?.sort((a: any, b: any) =>
            portfoliosCharts?.includes("allocation") ? 1 : b.value - a.value
          )
          ?.map((item: any, index: number) => (
            <div
              key={index}
              className="w-full justify-between items-center inline-flex"
            >
              <div className=" justify-start items-center gap-1 flex">
                <span
                  className={clsx(`w-2 h-2 rounded-full`)}
                  style={{ backgroundColor: Colors[index] }}
                ></span>
                <div className=" text-[#2a2a2a] text-xs font-semibold">
                  {item?.label}
                </div>
              </div>
              <div className=" text-right text-[#2a2a2a] text-xs font-semibold pe-3">
                {formatNumber(+item?.value, 2)}%
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default AssetsAllocation;
